import {
    HorizAlignment, ISearch, ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";



const vUI_Shipper_Product_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_PROD_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    PRODUCT_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PRODUCT_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    PRODUCT_SET_ID:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Set ID', columnResourceName: 'colSetID', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 10}},
    SOURCE_ID:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source ID', columnResourceName: 'colSourceID', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
     PRODUCT_TYPE:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Type', columnResourceName: 'colProductType', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    //WB_PROD_TYPE_ID:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Type', columnResourceName: 'colWBProductType', alignment: HorizAlignment.Left}, domainOptions: {  domainIds: "Product_Type", useIdAsKey: true, maxLength: 50}},
    PRODUCT_UPC:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product UPC', columnResourceName: 'colProductUPC', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CONSUMER_PRODUCT_UPC:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Cons Product UPC', columnResourceName: 'colConsProductUPC', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    STATUS_CODE:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Status Code', columnResourceName: 'colStatusCode', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    WEIGHT_FACTOR:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Weight Factor', columnResourceName: 'colWeightFactor', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
};

const ShipperProductSearch: ISearchProvider = {

    keyFields: {id:    'WB_PROD_ID',
        id_ui: 'PRODUCT_ID',
        name:  'PRODUCT_NAME'},


    searchProviderFields: vUI_Shipper_Product_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Shipper_Product_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

};


const ShipperProductSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "ShipperProductSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'PRODUCT_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'PRODUCT_NAME', renderOptions: { }},
        {profileFilterName: 'Set ID',     searchProviderFieldId: 'PRODUCT_SET_ID', renderOptions: { }},
        //{profileFilterName: 'Product Type',     searchProviderFieldId: 'PRODUCT_TYPE',bMultiSelect: true, renderOptions: { }},
      //  {profileFilterName: 'Product Type',     searchProviderFieldId: 'WB_PROD_TYPE_ID',bMultiSelect: true, renderOptions: { }},
        {profileFilterName: 'Product UPC',     searchProviderFieldId: 'PRODUCT_UPC', renderOptions: { }},
        {profileFilterName: 'Consumer UPC',     searchProviderFieldId: 'CONSUMER_PRODUCT_UPC', renderOptions: { }},
        {profileFilterName: 'Status Code',     searchProviderFieldId: 'STATUS_CODE', renderOptions: { }}

    ],  // ISearchFields
    profileDisplayFields: [
        'PRODUCT_ID','PRODUCT_NAME','PRODUCT_SET_ID','SOURCE_ID','PRODUCT_TYPE',//'WB_PROD_TYPE_ID',
        'PRODUCT_UPC','CONSUMER_PRODUCT_UPC','STATUS_CODE'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ShipperProductSearch,
    profileTreeIdDefault: "default",
    profileTrees: [
        {treeId: "default",
            treeName: "By Hierarchy",
            nodeProviders: [new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "Tree Path not set", levelDelimiter: "\\", ruggedTree: true})],
            renderOptions: {ui5: {leafIcon: "sap-icon://Chart-Tree-Map"}}}
    ],
    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};
const ShipperProductsSearch: ISearch = {
    searchName: "Find Shipper Product",
    renderOptions: { ui5ResourceId: "ShipperProductsSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ShipperProductSearchProfileByName]
};

PAEnvironment.registerBusinessObjectSearch("ProductBO", "ShipperProduct", ShipperProductsSearch, "Shipper Product Search")

export {ShipperProductsSearch}